import { makeStyles, createStyles } from 'styles/utils';

export const useStyles = makeStyles(_theme => createStyles({
  switch: {
    margin: '-7px 4px',
  },
}));